<template>
  <div class="navbar-wrap">
    <div class="navbar">
      <div class="logo">
        <img width="70px" src="../../../assets/images/login/logo_white.png" />
      </div>

      <div class="man-b">
        <div class="wz">常诚智慧工厂互联平台</div>
      </div>

      <div class="right-msg flex-vertical">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="drop-down">
            <span class="name">{{userName}}</span>
            <i
              class="el-icon-arrow-down el-icon--right"
              style="color: #fff;margin-top: 0px;cursor:pointer;"
            />
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">修改密码</el-dropdown-item>
            <el-dropdown-item command="0">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from "@/util/auth"
import { getUserMessageApi, logoutApi } from '@/util/api'
export default {
  data() {
    return {
      userName: "",
      token: '',
    }  
  },
  created() {
    this.token = getToken()
    getUserMessageApi().then(res => {
      if (res.code === 0) {
        this.userName = res.data.name || "-"; 
      } else {
        this.$message.warning(res.msg);
      }
    });
  },
  methods: {
    handleCommand(command) {
      if (command === "0") {
        logoutApi().then(res => {
          if (res.code === 0) {
            localStorage.removeItem('__username')

            this.$message({
              type: "success",
              message: "注销成功!"
            });
            removeToken();
            this.$router.push({ path: "/login" }).catch(data => console.log(data));
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (command === "1") {
        this.$router.push("/updatePwd");
      }
    }
  }
}
</script>

<style scoped lang="less">
@navHeight: 56px;
@manWrapHeight: 88px;
.navbar-wrap {
  position: relative;
  .navbar {
    position: relative;
    height: @navHeight;
    background: @top-nav-bg;
    display: flex;
    padding: 0 20px;
    align-items: center;
    color: #fff;

    .logo {
      margin-right: 20px;
      margin-left: 20px;
      display: flex;
      align-items: center;
      .text-logo{
        width: 26px;
        height: 30px;
      }
      .divide-line{
        width: 1px;
        height: 8px;
        margin: 0 15px;
        background: #fff;
      }
      .mark-logo{
        width: 28px;
        height: 28px;
      }
    }

    .man-b { 
      .wz {
        color: #EFEFEF;
        font-size: 16px; 
        font-weight: bold;
      }
    }
  }
  .right-msg {
    position: absolute;
    right: 20px;
    .person-img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    .drop-down {
      cursor: pointer;
      color: rgba(240, 242, 245, 1);
      .name{
        font-size: 16px;
      }
    }
  }
}
</style>
